import { axiosInstanceV2 } from "@src/shared/api";
import { USER_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

interface UpdateUserInfProps {
  first_name?: string;
  last_name?: string;
  middle_name?: string;
  phone?: string;
  email?: string;
}

export const updateUserInfo = ({
  email,
  data,
}: {
  email: string;
  data: UpdateUserInfProps;
}) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.patch(USER_API_URL.updateUserInfo(email), data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });
};
